export const getSummaryPendingAction = () => {};
